import { createContext, PropsWithChildren, useContext } from "react";

export type MDSUseModalGlobalHotkeysBlocker = (active: boolean) => void;

const noopUseModalGlobalHotkeysBlocker: MDSUseModalGlobalHotkeysBlocker = () => {};

const MDSModalGlobalHotkeysBlockerContext = createContext<MDSUseModalGlobalHotkeysBlocker>(
  noopUseModalGlobalHotkeysBlocker
);

type MDSModalGlobalHotkeysBlockerProviderProps = PropsWithChildren<{
  useModalGlobalHotkeysBlocker: MDSUseModalGlobalHotkeysBlocker;
}>;

/**
 * Lets app shells opt MDS modals into environment-specific global hotkey blocking.
 *
 * Design-system consumers that do not have app-level hotkeys can omit this
 * provider and `MDSModal` will fall back to a no-op blocker.
 */
export const MDSModalGlobalHotkeysBlockerProvider = ({
  children,
  useModalGlobalHotkeysBlocker,
}: MDSModalGlobalHotkeysBlockerProviderProps) => {
  return (
    <MDSModalGlobalHotkeysBlockerContext.Provider value={useModalGlobalHotkeysBlocker}>
      {children}
    </MDSModalGlobalHotkeysBlockerContext.Provider>
  );
};

export const useMDSModalGlobalHotkeysBlocker = () => {
  return useContext(MDSModalGlobalHotkeysBlockerContext);
};
